var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "27px",
  height: "26px",
  viewBox: "0 0 27 26",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-category",
  transform: "translate(-708.000000, -561.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Featured-stories",
  transform: "translate(104.000000, 533.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Budicon-Solid/Interface/star",
  transform: "translate(603.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M27.8155703,10.2045895 L21.2867543,16.0458375 L23.0238743,25.0928615 C23.0641957,25.3033059 22.9808983,25.5183098 22.8093204,25.6466596 C22.6377426,25.7750094 22.407967,25.7942014 22.2174743,25.6960935 L14.5300183,21.7273735 L6.84166627,25.6928455 C6.65061566,25.7915709 6.41990603,25.7721704 6.24802557,25.6429258 C6.07614512,25.5136813 5.99345938,25.2974259 6.03526627,25.0864775 L7.82390627,16.0519975 L1.30270627,10.2044775 C1.14405017,10.0598133 1.08207458,9.83717246 1.143164,9.63133858 C1.20425342,9.42550469 1.37765139,9.27272037 1.58953827,9.23802953 L10.1849783,7.85034953 L14.0621943,0.303789529 C14.158174,0.117250272 14.350363,0 14.5601463,0 C14.7699295,0 14.9621185,0.117250272 15.0580983,0.303789529 L18.9352023,7.85034953 L27.5287383,9.23780553 C27.7407765,9.27239798 27.9143325,9.4252489 27.9754403,9.63121657 C28.0365482,9.83718425 27.9744343,10.0599553 27.8155703,10.2045895 Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))))))));
export default SvgStar;